import React from "react";
import { Link } from "react-router-dom";
import chair from "../../image/chair.png";

const HeaderMain = () => {
  return (
    <main style={{ height: "600px" }} className="row d-flex align-items-center">
      <div className="col-md-4 offset-md-1">
        <h1 style={{ color: " #3e465a" }}>
          Your new smile <br /> Starts here
        </h1>
        <p className="text-secondary">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil fuga
          quisquam necessitatibus sint veniam quis.
        </p>
        <Link to="/appointment">
          <button className="btn btn-primary">GET APPOINTMENT</button>
        </Link>
      </div>

      <div className="col-md-6">
        <img src={chair} className=" img-fluid" alt="" />
      </div>
    </main>
  );
};

export default HeaderMain;
